import { render } from "./BulkMailing.vue?vue&type=template&id=9aa3d6b6"
import script from "./BulkMailing.vue?vue&type=script&lang=js"
export * from "./BulkMailing.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__